// extracted by mini-css-extract-plugin
export var cardGeneric = "Card-module--cardGeneric--8babc";
export var cardWithMedallion = "Card-module--cardWithMedallion--e1748";
export var reviewCard = "Card-module--reviewCard--e933d";